module.exports = __webpack_public_path__ + "static/img/5.84f3574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/5.png
// module id = vT6r
// module chunks = 35